/**
 * Detect if any asset's imageMediaMetadata dimensions changed between two
 * snapshots of the catalog assets list. Used by CatalogView to decide whether
 * the grid layout needs to be recalculated (e.g. after copy-converting with
 * resize completes and the asset is reloaded from DB with new dimensions).
 *
 * The comparison is shallow (width/height only) and keyed by asset _id so it
 * works regardless of reordering/additions/removals.
 * @param {Array<{ _id: string, imageMediaMetadata?: { width?: number, height?: number } }>} prevAssets
 * @param {Array<{ _id: string, imageMediaMetadata?: { width?: number, height?: number } }>} nextAssets
 * @returns {boolean}
 */
export default function hasImageMediaMetadataChanged(prevAssets, nextAssets) {
  if (prevAssets === nextAssets) return false;
  if (!Array.isArray(prevAssets) || !Array.isArray(nextAssets)) return false;
  if (!prevAssets.length || !nextAssets.length) return false;

  const prevById = new Map();
  for (let i = 0; i < prevAssets.length; i += 1) {
    const asset = prevAssets[i];
    if (asset && asset._id) prevById.set(asset._id, asset);
  }

  for (let i = 0; i < nextAssets.length; i += 1) {
    const next = nextAssets[i];
    const prev = next && next._id ? prevById.get(next._id) : null;
    if (prev) {
      const pm = prev.imageMediaMetadata;
      const nm = next.imageMediaMetadata;
      if (pm !== nm) {
        const pw = pm ? pm.width : undefined;
        const ph = pm ? pm.height : undefined;
        const nw = nm ? nm.width : undefined;
        const nh = nm ? nm.height : undefined;
        if (pw !== nw || ph !== nh) return true;
      }
    }
  }

  return false;
}
